import state from "@/store/state";

describe("state", () => {
  it("should have isLoading set to false", () => {
    expect(state.isLoading).toBe(false);
  });

  it("should have trackClickElement set to null", () => {
    expect(state.trackClickElement).toBe(null);
  });

  it("should have trackOnClickStart set to null", () => {
    expect(state.trackOnClickStart).toBe(null);
  });

  it("should have isExceeded set to false", () => {
    expect(state.isExceeded).toBe(false);
  });

  it("should have mock set to null", () => {
    expect(state.mock).toBe(null);
  });

  it("should have paso1 with initial values", () => {
    expect(state.paso1).toEqual({
      cuit: "",
      razonSocial: "",
      esPF: false,
      captcha: ""
    });
  });

  it("should have responseConsulta set to an empty object", () => {
    expect(state.responseConsulta).toEqual({});
  });

  it("should have paso2 with initial values", () => {
    expect(state.paso2).toEqual({
      camp: process.env.VUE_APP_CAMP || "",
      tipoActividad: "",
      rangoFacturacion: "",
      tipoDeCobro: "",
      lugarDeCobro: "",
      volumenDeOperaciones: ""
    });
  });

  it("should have paso3 with initial values", () => {
    expect(state.paso3).toEqual({
      camp: process.env.VUE_APP_CAMP || "",
      nombre: "",
      apellido: "",
      phone: { area: "", numero: "" },
      email: "",
      horario: "",
      cargoArea: ""
    });
  });

  it("should have paso4 with initial values", () => {
    expect(state.paso4).toEqual({
      numSucursal: "",
      dirSucursal: "",
      financiacion: false,
      cobrosPagos: false,
      seguroComercio: false
    });
  });

  it("should have notificationToast with initial values", () => {
    expect(state.notificationToast).toEqual({
      type: "",
      message: ""
    });
  });
});
